document.addEventListener('DOMContentLoaded', function () {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('animate');
        observer.unobserve(entry.target); // Gỡ theo dõi nếu chỉ cần animate 1 lần
      }
    });
  }, {
    threshold: 0.1 // Kích hoạt khi 10% phần tử xuất hiện
  });

  document.querySelectorAll('.fade-in-up').forEach(el => {
    observer.observe(el);
  });
});

/* ===== Blog page  ===== */
class BlogPagination extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', this.loadMoreItems);
  }

  loadMoreItems(){
    const urlFetch = this.dataset.href;
    fetch(urlFetch)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = new DOMParser().parseFromString(state, 'text/html');
        const getLinkNextPage = parsedState.querySelector('.js-blog-load-more');

        document.querySelector('.js-articles').innerHTML += parsedState.querySelector('.js-articles').innerHTML;
        this.closest('.js-blog-load-more').innerHTML = getLinkNextPage.innerHTML;
      });
  }
}
customElements.define("blog-pagination", BlogPagination);

class FlickityCarousel extends HTMLElement {
  constructor() {
    super();
    this.elem = this.querySelector('.main-carousel');
    this.flkty = new Flickity(this.elem, {
      cellAlign: 'left',
      contain: true
    });
  }
}

customElements.define('flickity-carousel', FlickityCarousel);

document.addEventListener("DOMContentLoaded", function () {
  if(document.querySelector('.sticky-add-to-cart-section')) {
    const stickySection = document.querySelector('.sticky-add-to-cart-section');
    const triggerSection = document.querySelector('.main-product-section');
    const header = document.querySelector('.section-header .header');

    // function getHeaderOffset() {
    //   const annHeight = parseInt(getComputedStyle(header).getPropertyValue('--announcement-height')) || 0;
    //   const headerHeight = parseInt(getComputedStyle(header).getPropertyValue('--header-height')) || 0;
    //   return annHeight + headerHeight;
    // }

    function getHeaderOffset() {
      const headerHeight = header.offsetHeight || 0;
      const announcementHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-height')) || 0;
      return headerHeight + announcementHeight;
    }

    function updateStickyState() {
      const headerOffset = getHeaderOffset();
      const triggerBottom = triggerSection.getBoundingClientRect().bottom;

      if (triggerBottom < 0) {
        stickySection.classList.add('sticky');
        stickySection.style.top = `${headerOffset}px`;
      } else {
        stickySection.classList.remove('sticky');
        stickySection.style.top = '';
      }
    }

    window.addEventListener('scroll', updateStickyState);
    window.addEventListener('resize', updateStickyState);

    updateStickyState();
  }
});

document.addEventListener('DOMContentLoaded', function () {
  const formColumn = document.querySelector('.product__grid-column--details');
  const triggerSection = document.querySelector('.main-product-section');
  const header = document.querySelector('.section-header .header');

  if (!formColumn || formColumn.classList.contains('not-sticky') || !triggerSection || !header) return;

  let announcementHeight = 0;
  let headerHeight = 0;

  function updateHeaderHeights() {
    announcementHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--announcement-height')) || 0;
    headerHeight = header.offsetHeight || 0;
  }

  function getHeaderOffset() {
    return headerHeight + announcementHeight;
  }

  function getStickyHeight() {
    const title = formColumn.querySelector('.product-block--title');
    const price = formColumn.querySelector('.product-block--price');
    const variant = formColumn.querySelector('.product-block--variant_picker');
    const buy = formColumn.querySelector('.product-block--buy_buttons');

    let totalHeight = 0;
    [title, price, variant, buy].forEach(el => {
      if (el && el.offsetHeight) totalHeight += el.offsetHeight;
    });

    return totalHeight;
  }

  let isSticky = false;

  function applySticky() {
    if (!isSticky) {
      isSticky = true;
      formColumn.classList.add('sticky', 'product-sticky-layout');
    }

    const offset = getHeaderOffset();
    formColumn.style.top = `${offset}px`;

    requestAnimationFrame(() => {
      formColumn.style.height = `${getStickyHeight()}px`;
    });
  }

  function removeSticky() {
    if (isSticky) {
      isSticky = false;
      formColumn.classList.remove('sticky', 'product-sticky-layout');
      formColumn.style.top = '';
      formColumn.style.height = '';
    }
  }

  function updateSticky() {
    updateHeaderHeights(); // <== luôn update headerHeight & announcementHeight

    const triggerBottom = triggerSection.getBoundingClientRect().bottom;
    if (triggerBottom < getHeaderOffset()) {
      applySticky();
    } else {
      removeSticky();
    }
  }

  let ticking = false;
  window.addEventListener('scroll', () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        updateSticky();
        ticking = false;
      });
      ticking = true;
    }
  });

  window.addEventListener('resize', updateSticky);

  // Initial call
  updateSticky();
});

document.querySelectorAll('.input-radio__input').forEach(input => {
  input.addEventListener('click', () => {
    const scrollY = window.scrollY;
    const scrollX = window.scrollX;
    requestAnimationFrame(() => {
      window.scrollTo(scrollX, scrollY);
    });
  });
});
class LogoScroll extends HTMLElement {
  constructor() {
    super();
    this.flickities = [];
    this.updateCallbacks = [];
  }

  connectedCallback() {
    this.init();
  }

  disconnectedCallback() {
    this.updateCallbacks.forEach(cancel => cancel && cancel());
    this.flickities.forEach(flickity => flickity.destroy());
    this.flickities = [];
    this.updateCallbacks = [];
  }

  init() {
    const listElems = this.querySelectorAll('.logo-carousel__slider');
    if (!listElems.length) return;

    listElems.forEach(elem => this.setupSlider(elem));
  }

  setupSlider(elem) {
    const dataItem = elem.getAttribute('data-class');
    const slideItem = this.querySelector(`[data-class=${dataItem}]`);
    if (!slideItem) return;

    const duration = Number(slideItem.getAttribute('data-duration')) / 10;
    let tickerSpeed = duration;
    if (elem.classList.contains('logo-carousel--left-right')) {
      tickerSpeed = -duration;
    }

    const flickity = new Flickity(slideItem, {
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: true,
      wrapAround: true,
      selectedAttraction: 0.015,
      friction: 0.25
    });

    if (elem.classList.contains('logo-carousel--left-right')) {
      flickity.x = flickity.slideableWidth;
    } else {
      flickity.x = 0;
    }

    const update = () => {
      if (flickity.slides) {
        flickity.x = (flickity.x - tickerSpeed) % flickity.slideableWidth;
        flickity.selectedIndex = flickity.dragEndRestingSelect();
        flickity.updateSelectedSlide();
        flickity.settle(flickity.x);
      }
      requestId = window.requestAnimationFrame(update);
    };

    let requestId = window.requestAnimationFrame(update);

    this.flickities.push(flickity);
    this.updateCallbacks.push(() => window.cancelAnimationFrame(requestId));
  }
}

customElements.define('logo-carousel', LogoScroll);

document.addEventListener('submit', (e) => {
  const form = e.target;
  form.querySelectorAll('textarea[required]').forEach(el => {
    if (el.offsetParent === null) {
      el.removeAttribute('required');
    }
  });
}, true); 

document.addEventListener('submit', async function (e) {
  const form = e.target.closest('form[action="/cart/add"]');
  if (!form) return;

  e.preventDefault();

  const formData = new FormData(form);

  try {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    });

    if (!res.ok) throw new Error('Thêm vào giỏ thất bại');

    const cart = await fetch('/cart.js').then(res => res.json());

    document.dispatchEvent(new CustomEvent('cart:update', {
      detail: { cart, count: cart.item_count }
    }));

  } catch (err) {
    console.error('Add to cart error:', err);
  }
});

if(document.querySelector('flickity-slider-mobile')) {
  class FlickitySliderMobile extends HTMLElement {
    constructor() {
      super();
      this.carousel = null;
      this.flickity = null;
    }

    connectedCallback() {
      if (!window.matchMedia('(max-width: 768px)').matches) return;

      this.carousel = this.querySelector('.carousel');
      if (!this.carousel) return;

      this.waitForImages().then(() => {
        this.flickity = new Flickity(this.carousel, {
          cellAlign: 'left',
          contain: true,
          pageDots: false,
          groupCells: true,
        });
      });
    }

    disconnectedCallback() {
      if (this.flickity) {
        this.flickity.destroy();
        this.flickity = null;
      }
    }

    waitForImages() {
      const images = this.querySelectorAll('img');
      const promises = Array.from(images).map(img => {
        if (img.complete && img.naturalHeight !== 0) {
          return Promise.resolve();
        }
        return new Promise(resolve => {
          img.onload = img.onerror = () => resolve();
        });
      });

      return Promise.all(promises);
    }
  }
  customElements.define('flickity-slider-mobile', FlickitySliderMobile);
}

document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.section-header');

  window.addEventListener('scroll', function () {
    const headerHeight = header.offsetHeight;

    if (window.scrollY > headerHeight) {
      header.classList.add('scrolled-past-header');
    } else {
      header.classList.remove('scrolled-past-header');
    }
  });
});

if (document.querySelector('[data-share-button]')) {
  document.querySelector('[data-share-button]').addEventListener('click', function() {
    document.querySelector('[data-share-article]').classList.toggle('hidden');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  const emailInputs = document.querySelectorAll('.js-validate-email');

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  }

  emailInputs.forEach(emailInput => {
    const form = emailInput.closest('form');
    const feedback = emailInput.parentElement.querySelector('.js-email-feedback');

    if (!form || !feedback) return;

    emailInput.addEventListener('input', function () {
      const emailValue = this.value.trim();

      if (emailValue === '') {
        feedback.textContent = '';
        this.classList.remove('error');
        this.removeAttribute('aria-invalid');
        return;
      }

      if (!isValidEmail(emailValue)) {
        feedback.textContent = 'Please enter a valid email address.';
        this.classList.add('error');
        this.setAttribute('aria-invalid', 'true');
      } else {
        feedback.textContent = '';
        this.classList.remove('error');
        this.removeAttribute('aria-invalid');
      }
    });

    form.addEventListener('submit', function (e) {
      const emailValue = emailInput.value.trim();

      if (!isValidEmail(emailValue)) {
        e.preventDefault();
        feedback.textContent = 'Please enter a valid email address.';
        emailInput.classList.add('error');
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
      }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(() => {
    const iconContainer = document.querySelector('.rp-micro-app-dummy-icon-container');
    if (iconContainer) {
      observer.disconnect();
      function isAtBottom() {
        return (window.innerHeight + window.scrollY) >= (document.body.offsetHeight - 1);
      }

      function updateIconPosition() {
        if (isAtBottom()) {
          if (window.innerWidth < 768) {
            iconContainer.style.setProperty('bottom', '140px', 'important');
          } else {
            iconContainer.style.setProperty('bottom', '80px', 'important');
          }
        } else {
          iconContainer.style.removeProperty('bottom');
        }
      }

      window.addEventListener('scroll', updateIconPosition);
      window.addEventListener('resize', updateIconPosition);
      updateIconPosition();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
});